import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as employeeApi from '../../../lib/api/employee';
import {  listRNR } from '../../../modules/empModule/empResume';
import RNRForm from '../../../components/employeemng/resume/RNRForm';



const RNRFormContainer = ({ employee }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    attrVal1: '',
    attrVal2: '',
    attrVal3: '',
  };

  const validationSchema = yup.object({
    attrVal1: yup.string('').required('업무분류명을 입력하세요'),
    attrVal2: yup.string().required('업무명을 입력하세요'),
    attrVal3: yup.string().required('업무년도를 입력하세요'),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        usrUuid: employee.usrUuid,
        infoTyp: 'RNR',
        attrVal1: values.attrVal1,
        attrVal2: values.attrVal2,
        attrVal3: values.attrVal3,
      };

      //console.log(JSON.stringify(dataToSubmit),'dataToSubmit');

      try {
        const response = await employeeApi.addResumeByEmp(dataToSubmit);
        if (response.data) {
          dispatch(
            listRNR({
              id: employee.usrUuid,
              infoTyp: 'RNR',
            }),
          );
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <RNRForm formik={formik} />;
};

export default RNRFormContainer;
